export const n12BackgroundColor = '#181424';
export const n12DataContainerColor = '#1b1c2e';
export const darkestRed = '#8e0923';
export const mainN12Red = '#b50100';
export const brightRed = '#f41121';
export const softRed = '#ff273e';
export const grayBeige = '#dcdac8';
export const beige = '#e3cfac';
export const darkBlue = '#0057c7';
export const mediumBlue = '#027be2';
export const lightBlue = '#61b2ff';
export const darkGrey = '#818386';

export const n12PieChartColors = [beige, darkBlue, mediumBlue, lightBlue];
export const n12BarColors = [darkestRed, softRed, darkGrey];
